import { request } from 'lib';

import { globalStore } from 'stores';

const init = () => {
  request.api
    .get('public/t_hex')
    .then((res) => {
      let time = parseInt(res.data, 16) * 1000;
      globalStore.setServerTime(time);
      window.SYS_TIME = time;
    })
    .catch((res) => {});
};

export default {
  init,
};
